import QUERY_KEYS from '@/constants/queryKeys';
import { api } from '@/services/burrbear-api/api.client';
import { GetRewardsQuery } from '@/services/burrbear-api/graphql/generated/api-types';
import useWeb3 from '@/services/web3/useWeb3';
import { AddressZero } from '@ethersproject/constants';
import { useQuery } from '@tanstack/vue-query';
import useNetwork from '../useNetwork';

export default function useMultiRewardsQuery() {
  const { networkId } = useNetwork();
  const { account, walletState } = useWeb3();

  // Make sure that if wallet is connected, it is not empty (to prevent duplicate queries)
  const isQueryEnabled = computed(
    () =>
      walletState.value === 'disconnected' ||
      (walletState.value === 'connected' && account.value !== '')
  );

  const queryKey = QUERY_KEYS.Pools.Rewards(networkId, account);

  const queryFn = async (): Promise<GetRewardsQuery> => {
    try {
      const { rewards, user } = await api.GetRewards({
        address: account.value || AddressZero,
      });
      return { rewards, user };
    } catch (error) {
      console.error('Failed to fetch pool rewards', error);
      return { rewards: [], user: null } as GetRewardsQuery;
    }
  };

  return useQuery<GetRewardsQuery>(queryKey, queryFn, {
    enabled: isQueryEnabled,
    staleTime: 10 * 1000, // Data stays fresh for 10 seconds
    cacheTime: 30 * 1000, // Cache persists for 30 seconds
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch when component mounts if data is still fresh
  });
}
